{
  "assets": {
    "upload_new": "Upload new {{ assetType }}"
  },
  "edit_layer": {
    "discard_title": "Unsaved changes",
    "discard_message": "By clicking yes you are agreeing to discard all the unsaved change made to this layer. Do you still wish to proceed?"
  },
  "move": {
    "moveTo": "Move to this location",
    "setTo": "Set new location",
    "tooltip": {
      "Map": "Cannot move into a plan",
      "Layer": "Cannot move into a layer"
    },
    "tooltip_self": "Cannot move a folder into itself"
  },
  "fixed_shape": {
    "length": "Length",
    "width": "Width"
  },
  "mapObjectSidebarOptions": {
    "hide_object": "Hide Object",
    "show_object": "Show Object",
    "hide_group": "Hide Group",
    "show_group": "Show Group"
  },
  "object_details": {
    "minimise": "Minimise object details",
    "edit_attributes": "Manage attributes",
    "object_details": "OBJECT DETAILS",
    "object_name": "Object name"
  },
  "verticalBarErrors": {
    "layer_hidden_drawing": "You cannot edit a layer that is hidden",
    "layer_locked_drawing": "You cannot edit a layer that is locked",
    "hide_layer_composition": "You cannot hide a layer whilst you are editing it",
    "group_composition": "You cannot hide a group whilst you are editing one of it's layers"
  },
  "export_map": {
    "export_map": "Export Plan",
    "export_preview": "Export preview",
    "lock_map": "Lock viewport",
    "orientation": {
      "title": "Page orientation",
      "portrait": "Portrait",
      "landscape": "Landscape"
    },
    "page_size": {
      "title": "Page size"
    },
    "file_format": {
      "title": "File format"
    },
    "scale": "Scale",
    "infoTooltip": {
      "title": "Viewport",
      "text": "Click the map to scroll and adjust your viewport then, lock the viewport to save the changes to your editor."
    },
    "positionMapOverlay": {
      "title": "Position the map",
      "text": "Pan, zoom, and rotate to choose the area to export"
    },
    "read_user_visibility_warning": "Exports exclude visibility changes from users without Full Access permission on the map."
  },
  "styles": {
    "customiseColour": "Customise colour",
    "scaleText": "Scale icon to fit text",
    "textMargin": "Text margin",
    "modelVariableSizeError": "Invalid value. Please ensure all values are between {{ minValue }} and {{ maxValue }}",
    "dimensions": "Dimensions",
    "customDimensions": "Customise models dimensions",
    "customColour": "Allow custom colour.",
    "customImage": "Allow custom image (aspect ratio optional).",
    "widthLengthHeight": "Width, Length, Height"
  },
  "permissions": {
    "permission_is": "Permission is",
    "readonly": "read-only",
    "map": "on plan",
    "layer": "on layer",
    "selection": "on selection"
  },
  "layer_overflow": {
    "hidden_text": "Layer overflow menu",
    "layer_properties": "Layer settings",
    "attribute_table": "Attribute table",
    "delete_layer": "Delete layer",
    "layer_view": {
      "display_text": "Layer view",
      "view_by_object": "View by object",
      "view_by_attribute": "View by attribute"
    },
    "remove_from_map": "Remove from plan",
    "manage_permissions": "Manage permissions"
  },
  "plan": "Plans",
  "dashboard": "Dashboard",
  "units": {
    "feet": "Feet"
  },
  "controls": {
    "set_pitch": "Tilt the view"
  },
  "toolbarButtonTooltips": {
    "helpButton": "Help",
    "layers": "Back to layers"
  }
}